import { v4 as uuidv4 } from 'uuid';
import { colorUtil } from "../../util/ColorUtil";

export const StarIcon = (props: {
  width: string;
  height: string;
  isSelected?: boolean;
  color?: string;
}) => {
  const filterId = uuidv4();
  const {
    isSelected = false,
    width,
    height,
    color = colorUtil.starIcon,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter={`url(#${filterId})`}>
        {isSelected ? (
          <path
            d="M18.0979 1.8541C18.6966 0.0114832 21.3034 0.0114789 21.9021 1.8541L24.2658 9.12868C24.5335 9.95272 25.3014 10.5106 26.1679 10.5106H33.8168C35.7543 10.5106 36.5598 12.9899 34.9924 14.1287L28.8043 18.6246C28.1033 19.1339 27.81 20.0366 28.0777 20.8607L30.4414 28.1353C31.0401 29.9779 28.9311 31.5101 27.3637 30.3713L21.1756 25.8754C20.4746 25.3661 19.5254 25.3661 18.8244 25.8754L12.6363 30.3713C11.0689 31.5101 8.95992 29.9779 9.55862 28.1353L11.9223 20.8607C12.19 20.0366 11.8967 19.1339 11.1957 18.6246L5.00761 14.1287C3.44018 12.9899 4.24573 10.5106 6.18318 10.5106H13.8321C14.6986 10.5106 15.4665 9.95272 15.7342 9.12868L18.0979 1.8541Z"
            fill={color}
          />
        ) : (
          <path
            d="M19.0489 2.16312C19.3483 1.2418 20.6517 1.24181 20.9511 2.16312L23.3147 9.43769C23.7163 10.6738 24.8682 11.5106 26.1679 11.5106H33.8168C34.7855 11.5106 35.1883 12.7503 34.4046 13.3197L28.2165 17.8156C27.165 18.5795 26.725 19.9336 27.1267 21.1697L29.4903 28.4443C29.7897 29.3656 28.7352 30.1317 27.9515 29.5623L21.7634 25.0664C20.7119 24.3024 19.2881 24.3024 18.2366 25.0664L12.0485 29.5623C11.2648 30.1317 10.2103 29.3656 10.5097 28.4443L12.8733 21.1697C13.275 19.9336 12.835 18.5795 11.7835 17.8156L5.5954 13.3197C4.81168 12.7503 5.21446 11.5106 6.18318 11.5106H13.8321C15.1318 11.5106 16.2837 10.6738 16.6853 9.43769L19.0489 2.16312Z"
            stroke={color}
            strokeWidth="2"
            shapeRendering="crispEdges"
          />
        )}
      </g>
      <defs>
        <filter
          id={filterId}
          x="0.179352"
          y="0.472168"
          width="39.6413"
          height="38.2903"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3_579"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3_579"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
